import { REQUEST_CARRIERS, REQUEST_CARRIERS_SUCCEEDED } from './carriersActions';

const InitialState = {};

export default function carriersByInsuranceTypeReducer(state = InitialState, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case REQUEST_CARRIERS:
            return {
                ...state,
                [payload.insuranceType]: [],
            };

        case REQUEST_CARRIERS_SUCCEEDED:
            return {
                ...state,
                [payload.insuranceType]: payload.carriers,
            };

        default:
            return state;
    }
}
